<template>
  <oie-my-pages-template :title="t('safetySettingsTitle')" :text="t('safetySettingsSubTitle')">
    <div>
      <div class="input-column">
        <validation-observer
          v-slot="{ invalid }"
          tag="form">
          <div class="input-column__container">
            <h2 class="edit-wrapper__title">
              {{ t('loginInformationHeader') }}
            </h2>

            <validation-provider rules="required" slim>
              <template v-slot="{ errors }">
                <oie-base-input
                  id="my-pages-old-password"
                  v-model="oldPassword"
                  type="password"
                  :label-text="`${t('currentPasswordLabel')}*`"
                  :placeholder="t('currentPasswordPlaceholder')"
                  :error-messages="errors"></oie-base-input>
              </template>
            </validation-provider>

            <validation-provider vid="pw" rules="required|passwordPolicy" slim>
              <template v-slot="{ errors }">
                <oie-base-input
                  id="my-pages-password"
                  v-model="newPassword"
                  type="password"
                  :label-text="`${t('newPasswordLabel')}*`"
                  :placeholder="t('newPasswordPlaceholder')"
                  :error-messages="errors"></oie-base-input>
              </template>
            </validation-provider>

            <validation-provider rules="required|password:pw" slim>
              <template v-slot="{errors}">
                <oie-base-input
                  id="my-pages-repeat-password"
                  v-model="confirmNewPassword"
                  type="password"
                  name="pwd"
                  :label-text="`${t('repeatPasswordLabel')}*`"
                  :placeholder="t('repeatPasswordLabel')"
                  :error-messages="errors"></oie-base-input>
              </template>
            </validation-provider>

            <oie-action-wrapper>
              <oie-base-action
                v-element-loader="{ endpoint: 'auth/change' }"
                size="large"
                :disabled="invalid"
                @click="changePassword">
                {{ tStatic('genericSave') }}
              </oie-base-action>
            </oie-action-wrapper>
          </div>
        </validation-observer>
      </div>
    </div>
  </oie-my-pages-template>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmNewPassword: null
    }
  },
  methods: {
    changePassword() {
      httpService.post('auth/change', { newPassword: this.newPassword, oldPassword: this.oldPassword })
    }
  }
}
</script>
